import * as React from 'react';
function IconBusinessSolutions(props) {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M0 0h24v24H0z" }),
            React.createElement("path", { d: "M22 3v14H2V3h20zm-1.5 1.5h-17v11h17v-11zM19 6v5h-1.5V8.542l-5.508 5.052-2.65-2.742-4.098 3.351-.95-1.16 5.167-4.225 2.594 2.683L16.416 7.5H14V6h5zm-5 11v2h2v2H8v-2h2v-2h4z", fill: "currentColor", fillRule: "nonzero" }))));
}
export default IconBusinessSolutions;
//# sourceMappingURL=IconBusinessSolutions.js.map